export default function HeroSection() {
  return (
    <section id="hero" className="relative w-full overflow-hidden bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-16 lg:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block text-sm font-medium tracking-wider text-primary-600 bg-primary-100/70 px-4 py-1.5 rounded-full whitespace-nowrap mb-4">
              热门影视 · 每日更新
            </span>
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-3">
              小辣椒影院 - 高清电影免费在线观看不卡顿
            </h1>
            <p className="text-base md:text-lg text-primary-500 font-medium mb-5 whitespace-nowrap">
              秒开流畅 · 画质清晰 · 完全免费
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              小辣椒影院是一个专业的高清影视在线平台，涵盖热门电影、经典佳作、最新电视剧和热门综艺等丰富内容。
              无论你想追最新上映的大片，还是重温经典老片，这里都能满足你的观影需求。
              本站每日同步更新海内外热门影视资源，高清画质流畅不卡顿，无需注册登录即可免费在线观看。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-accent-500">10000+</div>
                <div className="text-xs text-foreground-600 mt-0.5">已收录影视资源</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-accent-500">每日更新</div>
                <div className="text-xs text-foreground-600 mt-0.5">50+ 部新片上线</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-accent-500">99.9%</div>
                <div className="text-xs text-foreground-600 mt-0.5">播放成功率</div>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="whitespace-nowrap inline-flex items-center gap-2 bg-primary-500 text-background-50 font-medium px-6 py-3 rounded-md text-sm hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观影
              </a>
              <a
                href="#carousel"
                className="whitespace-nowrap inline-flex items-center gap-2 border border-background-300 text-foreground-800 font-medium px-6 py-3 rounded-md text-sm hover:bg-background-100 transition-colors cursor-pointer"
              >
                <i className="ri-compass-3-line text-lg"></i>
                浏览专题
              </a>
            </div>
          </div>
          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20projector%20emitting%20warm%20golden%20light%20on%20deep%20crimson%20textured%20abstract%20background%2C%20elegant%20movie%20theater%20atmosphere%20with%20film%20strip%20elements%2C%20soft%20dramatic%20lighting%2C%20artistic%20photography%20with%20vintage%20cinema%20aesthetic%2C%20luxurious%20and%20inviting%20ambiance%2C%20clean%20composition%20with%20ample%20negative%20space%2C%20warm%20red%20and%20gold%20tones&width=1200&height=900&seq=hero-visual-2026&orientation=landscape"
                alt="小辣椒影院 - 高清电影免费在线观看"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}